import type { ApiDelivery } from '@/features/kitchen/api/getTodayDispatch'
import type { ShipmentLineRecord, ShipmentRecord } from '@/features/kitchen/storage/dispatchStorage'
import { kitchenTodayISO } from '@/features/kitchen/lib/kitchenDates'

export type ApiShipment = ShipmentRecord & {
  deliveryId: string
}

function productionDateSortKey(productionDate: string): string {
  const [dd, mm, yy] = productionDate.split('/')
  if (!dd || !mm || !yy) return productionDate
  return `20${yy.padStart(2, '0')}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`
}

/** Gabung baris per produk (kompatibel data lama yang terpecah per lot). */
export function mergeDispatchLinesByProduct(lines: ShipmentLineRecord[]): ShipmentLineRecord[] {
  const merged = new Map<string, ShipmentLineRecord>()
  for (const line of lines) {
    const existing = merged.get(line.productName)
    if (!existing) {
      merged.set(line.productName, { ...line })
      continue
    }
    existing.qty += line.qty
    if (
      productionDateSortKey(line.productionDate) <
      productionDateSortKey(existing.productionDate)
    ) {
      existing.productionDate = line.productionDate
    }
  }
  return [...merged.values()]
}

export function mapDeliveriesFromApi(deliveries: ApiDelivery[]): ApiShipment[] {
  const today = kitchenTodayISO()
  return deliveries.map((d) => ({
    deliveryId: d.id,
    id: d.code || d.id,
    storeName: d.store_name,
    delmanName: d.delman_name,
    tripDate: d.trip_date || today,
    status: d.status,
    updatedAt: d.updated_at,
    lines: mergeDispatchLinesByProduct(
      (d.lines ?? []).map((line) => ({
        id: line.id,
        productName: line.product_name,
        productionDate: line.production_date,
        qty: line.qty,
      })),
    ),
  }))
}

export function buildDispatchSummaryFromShipments(
  shipments: Pick<ShipmentRecord, 'status' | 'storeName'>[],
) {
  const pending = shipments.filter((s) => s.status === 'draft' || s.status === 'prepared')
  const inTransit = shipments.filter((s) => s.status === 'in_transit')
  const prepared = shipments.filter((s) => s.status === 'prepared')

  return {
    pendingCount: pending.length,
    preparedCount: prepared.length,
    inTransitCount: inTransit.length,
    pendingStores: pending.map((s) => s.storeName),
  }
}
